import { Box, Container, Typography, Divider, Link, Paper, Stack, Chip } from '@mui/material';
import { PublicSiteChrome, publicPageSx } from '../site/PublicSiteChrome';
import Footer from '../Footer';

const TOKENS = {
  primary: '#1E40AF',
  secondary: '#3B82F6',
  accent: '#D97706',
  bgDark: '#0B132B',
  bgCard: 'rgba(15, 23, 42, 0.75)',
  border: 'rgba(219, 234, 254, 0.15)',
  textPrimary: '#F8FAFC',
  textSecondary: '#94A3B8',
  textHighlight: '#60A5FA',
};

const sectionTitleSx = {
  fontWeight: 700,
  fontSize: { xs: '1.25rem', sm: '1.5rem' },
  color: TOKENS.textPrimary,
  mt: 4,
  mb: 2,
};

const textSx = {
  color: TOKENS.textSecondary,
  fontSize: { xs: '0.92rem', sm: '1rem' },
  lineHeight: 1.7,
  mb: 2,
};

const TermsOfService = () => {
  const lastUpdated = 'July 20, 2026';

  return (
    <Box sx={{ ...publicPageSx, bgcolor: TOKENS.bgDark, color: TOKENS.textPrimary }}>
      <PublicSiteChrome title="Terms of Service" />

      <Container maxWidth="md" sx={{ py: { xs: 6, md: 10 } }}>
        <Paper
          sx={{
            p: { xs: 4, sm: 6 },
            bgcolor: TOKENS.bgCard,
            border: `1px solid ${TOKENS.border}`,
            borderRadius: 3,
          }}
        >
          <Stack spacing={2} sx={{ mb: 4 }}>
            <Chip
              label="LEGAL AGREEMENT"
              size="small"
              sx={{
                alignSelf: 'flex-start',
                bgcolor: 'rgba(217, 119, 6, 0.18)',
                color: TOKENS.accent,
                fontWeight: 800,
                fontSize: 10,
              }}
            />
            <Typography variant="h3" sx={{ fontWeight: 800, letterSpacing: '-0.03em' }}>
              Terms of Service
            </Typography>
            <Typography sx={{ color: TOKENS.textSecondary, fontSize: '0.9rem' }}>
              Last Updated: {lastUpdated}
            </Typography>
          </Stack>

          <Divider sx={{ borderColor: TOKENS.border, mb: 4 }} />

          <Typography component="h2" sx={sectionTitleSx}>
            1. Acceptance of Terms
          </Typography>
          <Typography sx={textSx}>
            By accessing or using the GeoVera platform ("Service," "Platform," "we," "us," or
            "our"), including our WebGIS interface, DIGIPIN API, and QGIS extensions, you agree to
            be bound by these Terms of Service. If you do not agree to these terms, you must not
            access or use the Service.
          </Typography>

          <Typography component="h2" sx={sectionTitleSx}>
            2. Platform Description
          </Typography>
          <Typography sx={textSx}>
            GeoVera provides a cloud-based Geographic Information System (WebGIS) platform allowing
            users to manage vector and raster layers, perform spatial analysis, convert CAD formats,
            and integrate with India Post DIGIPIN location grid standard.
          </Typography>

          <Typography component="h2" sx={sectionTitleSx}>
            3. User Accounts & Google OAuth
          </Typography>
          <Typography sx={textSx}>
            Authentication on GeoVera is handled via Google OAuth 2.0. You are responsible for
            maintaining the security of your Google account credentials. GeoVera does not store or
            process user passwords.
          </Typography>

          <Typography component="h2" sx={sectionTitleSx}>
            4. DIGIPIN API & Plugin Usage
          </Typography>
          <Typography sx={textSx}>
            API keys issued for DIGIPIN Encoder Pro are for personal or organizational use as
            approved during request. Rate limits apply to prevent abuse. Revoked keys stop
            functioning immediately.
          </Typography>

          <Typography component="h2" sx={sectionTitleSx}>
            5. Contact Information
          </Typography>
          <Typography sx={textSx}>
            For legal inquiries, contact{' '}
            <Link
              href="mailto:legal@geovera.in"
              sx={{ color: TOKENS.textHighlight, fontWeight: 600 }}
            >
              legal@geovera.in
            </Link>
            .
          </Typography>
        </Paper>
      </Container>

      <Footer />
    </Box>
  );
};

export default TermsOfService;
